import React, { useEffect, createContext, useContext } from 'react';
type Theme = 'light';
interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export function ThemeProvider({
  children
}: {
  children: ReactNode;
}) {
  // Always light theme
  const theme: Theme = 'light';
  // Remove dark class if it exists
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    localStorage.removeItem('criket_theme');
  }, []);
  const toggleTheme = () => {
    // Do nothing - theme is always light
  };
  return <ThemeContext.Provider value={{
    theme,
    toggleTheme
  }} data-id="element-689">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}